import DeleteBatchNotificationDialogHtml from "./DeleteBatchNotificationDialogHtml.js";

export default class DeleteBatchNotificationDialogCmp {
    #html = new DeleteBatchNotificationDialogHtml()
    #callbacks = {
        onOk: ()=>{}
    }

    /** @param {number} selectedSize */
    show(selectedSize){
        this.#html.show(selectedSize);
        this.#html.onOkCb(this.#onOk.bind(this))
    }

    /** @param {function} callback */
    onOkCb(callback) {
        this.#callbacks.onOk = callback;
    }

    /** @param {boolean} isVisible */
    toggleProgressBarVisibility(isVisible){
        this.#html.toggleProgressBarVisibility(isVisible)
    }

    /** @param {string} action */
    #onOk(action){
        this.toggleProgressBarVisibility(true)
        this.#callbacks.onOk(action)
    }

    static ACT_ON_NESTED_METHODS = {
        DELETE: "DELETE",
        UNASSIGN: "UNASSIGN"
    }
}